import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { signUpRequest } from '../../../features/auth/ducks';
import { apiCallIds } from '../../../features/auth/api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import SignUpForm from '../components/creditor/SignUpForm';
import { push } from 'react-router-redux';

const mapStateToProps = (state, ownProps) => ({
  currentLocationState: ownProps.location.state,
  isLoading: selectIsInProgress(state, apiCallIds.SIGN_UP),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signUp: signUpRequest,
    },
    dispatch
  ),
  goToSignUp: calculator =>
    dispatch(push({ pathname: 'onboarding/creditor/sign-up', state: { calculator } })),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class OnboardingCreditorContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    currentLocationState: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props)

    this.state = {
      amount: null,
      months: null,
      interest: null,
      profit: null
    }
  }

  componentWillMount() {   
    let urlLocationHash = new URLSearchParams(window.location.search)

    let param = urlLocationHash.get('f')

    if(param === null) {
      if(this.props.currentLocationState.calculator) {
        const { amount, months, interest, profit } = this.props.currentLocationState.calculator    
    
        this.setState({
          amount: amount,
          months: months,
          interest: interest,
          profit: profit
        })
      }
    } else {
      try {
        let urlObject = JSON.parse(atob(param))
        let newState = {
          amount: urlObject.a,
          months: urlObject.m,
          interest: urlObject.i,
          profit: urlObject.p
        }

        const url = new URL(window.location)
        url.searchParams.delete('f')
        window.history.replaceState(null, null, url)

        this.setState(newState)
        this.props.goToSignUp(newState)
      } catch(e) {
        console.log(e)
      }
    }
  }

  onSubmit = accountData => {
    this.props.actions.signUp({ type: 'creditor', accountData });
  };

  render() {
    const { isLoading } = this.props;
    const { amount, months, interest, profit }= this.state    

    if(amount === null || months === null || interest === null || profit === null) {
      return 'Nastala chyba, kontaktujte nás prosím prostredníctvom kontaktného formulára.'
    }

    return (
      <SignUpForm
        isLoading={isLoading}
        amount={amount}
        months={months}
        interest={interest}
        profit={profit}
        onSubmit={this.onSubmit}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/containers/OnboardingCreditorContainer.js